import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import UnauthorizedScreen from '../../../components/UnauthorizedScreen/UnauthorizedScreen';
import { newEscolaRoute } from '../../../library/Routes';
import { isAuthorizedRequest } from '../../../utils/httpResponseHandlers';
import { getElementID } from '../../../utils/HTMLUtils';
import { getSearchText } from '../../../utils/SearchUtils';
import schoolBlackIcon from './../../../assets/images/svg/school-black-icon.svg';
import { Col } from './../../../components/Col';
import { Container } from './../../../components/Container';
import { CustomButton } from './../../../components/CustomButton';
import { EscolaItem } from './../../../components/EscolaItem';
import { Row } from './../../../components/Row';
import { SearchTextField } from './../../../components/SearchTextField';
import {
  clearEscolaEditing,
  clearEscolasPageList,
  loadEscolasPaginados,
  setCurrentTab,
} from './../../../store/modules/EscolasActions';
import { openModal } from './../../../store/modules/ModalActions';
import styles from './Escolas.scss';
import CustomSelect from 'components/CustomSelect';
import { SearchFiltersContainer } from 'components/SearchFiltersContainer';
import {
  ESCOLA_EDIT_FILTER_ESTADUAL,
  ESCOLA_EDIT_FILTER_MUNICIPAL,
  ESCOLA_EDIT_FILTER_PRIVADA,
} from 'library/EscolaEditCampoTipoDeInstituicao.js';
import {
  ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL,
  ESCOLA_EDIT_FILTER_EJA,
  ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL,
  ESCOLA_EDIT_FILTER_ENSINO_MEDIO,
  ESCOLA_EDIT_FILTER_ESPECIALIZADO,
  ESCOLA_EDIT_FILTER_OUTRO,
} from 'library/EscolaEditCampoEtapaDaEducacao';
import { ArrowDownwardOutlined } from '@material-ui/icons';
import Loader from 'components/Loader/Loader';
import { EscolaEditTabs } from '../Cadastro/etapas/ProgramasEducacionais/__enum';

const rootClassName = styles.rootClassName;
const rootElementId = 'escolas';
const INITIAL_STATE = {
  authorizedRequest: true,
  selectedTipoInstituicao: '',
  selectedEtapaEducacao: [],
  allTipoInstituicao: '',
  allEtapaEducacao: '',
};
class Escolas extends Component {
  isFirstLoad = true;
  constructor(props) {
    super(props);
    this.state = {
      authorizedRequest: true,
      ...INITIAL_STATE,
      allTipoInstituicao: [
        {
          id: ESCOLA_EDIT_FILTER_MUNICIPAL,
          name: this.props.languageValues.escolaEditTipoDeInstituicaoMunicipal,
        },
        {
          id: ESCOLA_EDIT_FILTER_ESTADUAL,
          name: this.props.languageValues.escolaEditTipoDeInstituicaoEstadual,
        },
        {
          id: ESCOLA_EDIT_FILTER_PRIVADA,
          name: this.props.languageValues.escolaEditTipoDeInstituicaoPrivada,
        },
      ],
      allEtapasDaEducacao: [
        {
          id: ESCOLA_EDIT_FILTER_EDUCACAO_INFANTIL,
          name: this.props.languageValues.escolaEditEtapasDaEducacaoInfantil,
        },
        {
          id: ESCOLA_EDIT_FILTER_ENSINO_FUNDAMENTAL,
          name: this.props.languageValues
            .escolaEditEtapasDaEducacaoEnsinoFundamental,
        },
        {
          id: ESCOLA_EDIT_FILTER_ENSINO_MEDIO,
          name: this.props.languageValues.escolaEditEtapasDaEducacaoEnsinoMedio,
        },
        {
          id: ESCOLA_EDIT_FILTER_ESPECIALIZADO,
          name: this.props.languageValues
            .escolaEditEtapasDaEducacaoEspecializado,
        },
        {
          id: ESCOLA_EDIT_FILTER_EJA,
          name: this.props.languageValues
            .escolaEditEtapasDaEducacaoEja,
        },
        {
          id: ESCOLA_EDIT_FILTER_OUTRO,
          name: this.props.languageValues.escolaEditEtapasDaEducacaoOutro,
        },
      ],
      searching: true,
      searchingText: '',
    };

    this.toSearch = this.toSearch.bind(this);
    this.changeSearchingStatus = this.changeSearchingStatus.bind(this);
    this.refreshList = this.refreshList.bind(this);
    this.toNewEscola = this.toNewEscola.bind(this);
    this.toNewSearch = this.toNewSearch.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.toSearch();
  }
  changeSelectedTipoInstituicao(newStatus) {
    this.props.clearEscolasPageList();
    if (this.state.selectedTipoInstituicao !== newStatus) {
      this.setState(
        {
          selectedTipoInstituicao: newStatus,
        },
        () => {
          this.toSearch(this.props.escolas.pageList.filtro);
          this.props.clearEscolasPageList();
        }
      );
    }
  }

  changeSelectedEtapaEducacao(newStatus) {
    this.props.clearEscolasPageList();
    if (this.state.selectedEtapaEducacao !== newStatus) {
      this.setState(
        {
          selectedEtapaEducacao: newStatus,
        },
        () => {
          this.toSearch(this.props.escolas.pageList.filtro);
          this.props.clearEscolasPageList();
        }
      );
    }
  }

  changeSearchingStatus(isSearching, moreProps = {}) {
    if (isSearching !== this.state.searching) {
      this.setState({
        ...this.state,
        searching: isSearching,
        ...moreProps,
      });
    }
  }

  toSearch(text, page, size) {
    const filtro = getSearchText(text || ' ');
    page =
      page ||
      (this.props.escolas.pageList.page < 1
        ? 1
        : this.props.escolas.pageList.page + 1);
    size = size || this.props.escolas.pageSize;
    const tipoInstituicao = this.state.selectedTipoInstituicao;
    const etapasEducacao = this.state.selectedEtapaEducacao.map(String);
    const params = new URLSearchParams();
    params.append('filtro', filtro);
    params.append('tipoInstituicao', tipoInstituicao);
    params.append('etapasEducacao', etapasEducacao.join(','));
    params.append('page', page);
    params.append('size', size);
    const queryString = params.toString();
    this.props.loadEscolasPaginados(
      queryString,
      () => {
        this.changeSearchingStatus(false);
        this.isFirstLoad = false;
      },
      (error) => {
        if (isAuthorizedRequest(error.response)) {
          this.changeSearchingStatus(false);
          this.isFirstLoad = false;
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              this.props.languageValues.errorSearchingEscolas,
            options: {
              variant: 'error',
            },
          });
        } else {
          this.changeSearchingStatus(false, {
            authorizedRequest: false,
          });
        }
      }
    );
  }

  refreshList() {
    const page = this.props.escolas.pageList.page;
    this.props.clearEscolasPageList();
    this.toSearch(this.state.searchingText, page);
  }

  componentWillUnmount() {
    this.props.clearEscolasPageList();
    this.isFirstLoad = true;
  }

  showLoadMore() {
    if (this.state.searching) {
      return false;
    }
    if (
      this.props.escolas.pageList.totalElements >
      this.props.escolas.pageList.elements.length
    ) {
      return true;
    }
    return false;
  }

  getPreloader = () => {
    return (
      <Row>
        <Col
          cols={[12, 12, 12, 12, 12]}
          className='load-more-container'
        >
          <div className='preloader'>
            <Loader dotWidth='12px' dotHeight='12px' dotMargin='0,3' />
          </div>
        </Col>
      </Row>
    );
  };

  toLoadMore() {
    this.toSearch(this.props.escolas.pageList.filtro);
  }

  getLegendResults() {
    let legend = '';
    const text = this.state.searchingText;
    if (this.props.escolas.pageList.totalElements === 1) {
      legend =
        text.length === 0
          ? this.props.languageValues.legendEscolasResultSingularEmpty
          : this.props.languageValues.legendEscolasResultSingular;
    } else {
      legend =
        text.length === 0
          ? this.props.languageValues.legendEscolasResultPluralEmpty
          : this.props.languageValues.legendEscolasResultPlural;
    }
    return (
      legend
        /* eslint-disable-next-line */
        .split('${1}')
        .join(this.props.escolas.pageList.elements.length)
        /* eslint-disable-next-line */
        .split('${2}')
        .join(this.props.escolas.pageList.totalElements)
        /* eslint-disable-next-line */
        .split('${3}')
        .join(this.state.searchingText)
    );
  }

  toNewEscola() {
    this.props.clearEscolaEditing();
    localStorage.removeItem('assessorPrograma');
    this.props.setCurrentTab(EscolaEditTabs.Informacoes)
    this.props.history.push(newEscolaRoute.path);
  }

  toNewSearch(newText) {
    this.props.clearEscolasPageList();
    this.toSearch(newText, 1);
  }

  render() {
    return this.state.authorizedRequest &&
      this.props.auth.userPermissions.escolas.list ? (
      <Container className={rootClassName + '-container container-fluid'}>
        <div className='container-fluid'>
          <Row className={rootClassName + '-header'}>
            {this.props.auth.userPermissions.escolas.register ? (
              <Col cols={[12, 12, 4, 3, 3]}>
                <CustomButton
                  id={getElementID(rootElementId, 'create')}
                  theme='pufvYellow'
                  className={rootClassName + '-create-button'}
                  label={this.props.languageValues.newEscolaButton}
                  rightIcon={<img src={schoolBlackIcon} alt='icone-escola' loading='lazy' />}
                  onClick={this.toNewEscola}
                />
              </Col>
            ) : null}
            <Col
              cols={
                this.props.auth.userPermissions.escolas.register
                  ? [12, 12, 8, 9, 9]
                  : [12, 12, 12, 12, 12]
              }
            >
              <SearchTextField
                id={rootElementId + '-search'}
                disabled={this.state.searching}
                onSearchClick={this.toNewSearch}
                placeholder={this.props.languageValues.escolasSearchPlaceholder}
              />
            </Col>
          </Row>

          <SearchFiltersContainer className='margin-bottom-40'>
            <Row>
              <Col
                cols={
                  this.props.auth.userPermissions.escolas.register
                    ? [12, 12, 12, 3, 2]
                    : [12, 12, 12, 12, 12]
                }
              >
                <CustomSelect
                  label={this.props.languageValues.escolaTipoDeInstituicaoLabel}
                  className={rootClassName + '-todasInstituicao-filter'}
                  id={'todasIntituicao_id'}
                  placeholder='Todas as instituições'
                  inputClassName={
                    rootClassName + '-todasInstituicao-input-filter'
                  }
                  options={this.state.allTipoInstituicao.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  })}
                  value={this.state.selectedTipoInstituicao}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !== this.state.selectedTipoInstituicao
                    ) {
                      this.changeSelectedTipoInstituicao(value);
                    }
                  }}
                  multiple={true}
                />
              </Col>

              <Col
                className='col_filter_etapaEducacao'
                cols={
                  this.props.auth.userPermissions.escolas.register
                    ? [12, 12, 12, 3, 2]
                    : [12, 12, 12, 12, 12]
                }
              >
                <CustomSelect
                  placeholder='Todas as etapas da educação'
                  label={this.props.languageValues.escolaEtapasDaEducacaoLabel}
                  className={rootClassName + '-etapasEducacao-filter'}
                  id={'etapasEducacao_id'}
                  inputClassName={
                    rootClassName + '-etapasEducacao-input-filter'
                  }
                  options={this.state.allEtapasDaEducacao.map((item) => {
                    return {
                      label: item.name,
                      value: item.id,
                    };
                  })}
                  value={this.state.selectedEtapaEducacao}
                  onChange={(value) => {
                    if (
                      value &&
                      value.value !== this.state.selectedEtapaEducacao
                    ) {
                      this.changeSelectedEtapaEducacao(value);
                    }
                  }}
                  multiple={true}
                />
              </Col>
            </Row>
          </SearchFiltersContainer>

          {!this.state.searching ? (
            <Row>
              <Col cols={[12, 12, 12, 12, 12]}>{this.getLegendResults()}</Col>
            </Row>
          ) : (
            ''
          )}
          <Row>
            {this.props.escolas.pageList.elements.map((escola, index) => {
              return (
                <EscolaItem
                  id={rootElementId + '-item-' + index}
                  escola={escola}
                  key={index}
                  savedCallback={this.refreshList}
                />
              );
            })}
          </Row>
          {this.showLoadMore() ? (
            <Row>
              <Col
                cols={[12, 12, 12, 12, 12]}
                className={rootClassName + '-load-more-container'}
              >
                <CustomButton
                  id={getElementID(rootElementId, 'load-more')}
                  theme='pufvYellow'
                  label={this.props.languageValues.loadMoreEscolaButton}
                  onClick={() => this.toLoadMore()}
                  rightIcon={<ArrowDownwardOutlined />}
                />
              </Col>
            </Row>
          ) : (
            ''
          )}
          {this.state.searching ? this.getPreloader() : ''}
        </div>
      </Container>
    ) : (
      <UnauthorizedScreen />
    );
  }
}
const mapStateToProps = (state) => ({
  languageValues: state.languages.languageValues,
  escolas: state.escolas,
  auth: state.auth,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      clearEscolasPageList,
      loadEscolasPaginados,
      openModal,
      clearEscolaEditing,
      setCurrentTab,
    },
    dispatch
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Escolas));
